export const MWEB_CART = "%2Fweb-food-cart%3Fflow%3Dcart%26sourceApp%3Dmweb";
export const STATIC_MWEB_CART = "%2Fstatic-web-food-cart%3Fflow%3Dcart%26sourceApp%3Dmweb";
